var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.group.isAdvanceRegistration
        ? [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.group.isVisitorGroup,
                    expression: "group.isVisitorGroup"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: _vm.uid + "isVisitorGroup" },
                domProps: {
                  checked: Array.isArray(_vm.group.isVisitorGroup)
                    ? _vm._i(_vm.group.isVisitorGroup, null) > -1
                    : _vm.group.isVisitorGroup
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.group.isVisitorGroup,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.group,
                            "isVisitorGroup",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.group,
                            "isVisitorGroup",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.group, "isVisitorGroup", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: _vm.uid + "isVisitorGroup" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("survey.group.model.isVisitorGroup")) +
                      "\n      "
                  )
                ]
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.group.isAdvanceRegistration
        ? [
            _vm.canToggleEnableScanEntry
              ? _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.group.enableScanEntry,
                        expression: "group.enableScanEntry"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: _vm.uid + "enableScanEntry"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.group.enableScanEntry)
                        ? _vm._i(_vm.group.enableScanEntry, null) > -1
                        : _vm.group.enableScanEntry
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.group.enableScanEntry,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.group,
                                "enableScanEntry",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.group,
                                "enableScanEntry",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.group, "enableScanEntry", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: _vm.uid + "enableScanEntry" }
                    },
                    [
                      _c("i", { staticClass: "fa fa-qrcode" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("survey.group.model.enableScanEntry")) +
                          "\n      "
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.group.enableScanEntry
              ? _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("survey.group.scanEntryDateRange")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("DateRangePicker", {
                        staticClass: "w-100",
                        attrs: {
                          localeData: _vm.dateRangePickerLocale,
                          timePicker: true,
                          timePicker24Hour: true,
                          showWeekNumbers: true,
                          showDropdowns: true,
                          autoApply: true,
                          ranges: false,
                          minDate: _vm.minDate
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function(picker) {
                                return [
                                  _vm._t(
                                    "datePickerText",
                                    function() {
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              picker.startDate
                                                ? _vm.formatDateTime(
                                                    picker.startDate
                                                  )
                                                : _vm.$t("generalAlways")
                                            ) +
                                            " -\n              " +
                                            _vm._s(
                                              picker.endDate
                                                ? _vm.formatDateTime(
                                                    picker.endDate
                                                  )
                                                : _vm.$t("generalAlways")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    },
                                    {
                                      startDate: picker.startDate,
                                      endDate: picker.endDate
                                    }
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.dateRange,
                          callback: function($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("survey.group.model.responsibleContact")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-row" },
                [
                  _c("vSelect", {
                    staticClass: "flex-grow-1",
                    attrs: {
                      options: _vm.contacts,
                      label: "label",
                      reduce: e => e.contact.id,
                      clearable: true,
                      appendToBody: true,
                      "calculate-position": _vm.vSelectInModalWithPopper
                    },
                    model: {
                      value: _vm.group.responsibleContactId,
                      callback: function($$v) {
                        _vm.$set(_vm.group, "responsibleContactId", $$v)
                      },
                      expression: "group.responsibleContactId"
                    }
                  }),
                  _vm._v(" "),
                  _vm.responsibleContactMsTeamsUrl
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-secondary ml-1",
                          attrs: {
                            href: _vm.responsibleContactMsTeamsUrl,
                            title: _vm.$t("general.audioCallInMsTeams")
                          }
                        },
                        [_c("i", { staticClass: "fa fa-headset" })]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("survey.group.model.responsibleFallbackContact")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-row" },
                [
                  _c("vSelect", {
                    staticClass: "flex-grow-1",
                    attrs: {
                      options: _vm.contacts,
                      label: "label",
                      reduce: e => e.contact.id,
                      clearable: true,
                      appendToBody: true,
                      "calculate-position": _vm.vSelectInModalWithPopper
                    },
                    model: {
                      value: _vm.group.responsibleFallbackContactId,
                      callback: function($$v) {
                        _vm.$set(_vm.group, "responsibleFallbackContactId", $$v)
                      },
                      expression: "group.responsibleFallbackContactId"
                    }
                  }),
                  _vm._v(" "),
                  _vm.responsibleFallbackContactMsTeamsUrl
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-secondary ml-1",
                          attrs: {
                            href: _vm.responsibleFallbackContactMsTeamsUrl,
                            title: _vm.$t("general.audioCallInMsTeams")
                          }
                        },
                        [_c("i", { staticClass: "fa fa-headset" })]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm._t(
                  "approvals",
                  function() {
                    return [
                      _c("Approvals", {
                        attrs: {
                          group: _vm.group,
                          hideApprovalStati: _vm.hideApprovalStati
                        }
                      })
                    ]
                  },
                  { group: _vm.group, hideApprovalStati: _vm.hideApprovalStati }
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm._t(
                  "informationGroups",
                  function() {
                    return [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "survey.group.model.informationGroupMappings"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("InformationGroupSelectCheckBoxes", {
                        attrs: { groupSurveyExtension: _vm.group }
                      })
                    ]
                  },
                  { group: _vm.group }
                )
              ],
              2
            ),
            _vm._v(" "),
            _vm.group.extraInfoJson !== "[]"
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("survey.group.model.extraInfoJson")))
                    ]),
                    _vm._v(" "),
                    _c("ExtraInfo", { attrs: { group: _vm.group } })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }